import {observer} from 'mobx-react';
import {useRouter} from 'next/router';
import React from 'react';

import {TrackerInitializer} from '@udemy/event-tracking';
import {Footer} from '@udemy/footer';
import {Header} from '@udemy/react-header';
import {Toaster} from '@udemy/react-messaging-components';
import {useStores} from '@udemy/store-provider';

import {RootStore} from 'src/stores/root-store';

import styles from './layout.module.less';

export const getLayout = (page: React.ReactElement) => {
    return <Layout>{page}</Layout>;
};

const Layout = observer(({children}: {children: React.ReactElement}) => {
    const [rootStore] = useStores([RootStore]);
    const router = useRouter();
    const displayType = router.query.display_type as string;
    const hasMobileAppQueryParam = displayType === 'mobile_app';

    return (
        <>
            {/* TODO: remove SmartBar rendering from Header component, re-add it here */}
            {/* <SmartBar /> */}
            <div className={styles['container']}>
                {!hasMobileAppQueryParam && <Header {...rootStore.headerData} />}
                <main className={styles['content']} id="main-content-anchor">
                    {children}
                </main>
                <Footer clientProps={rootStore.footerData} serverProps={rootStore.footerData} />
                <Toaster />
            </div>
            <TrackerInitializer />
        </>
    );
});
